import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE } from 'ducks/slice';

import { popover_default } from './defaults';
import { Popover, PopoverClear, PopoverUpdate } from './types';
import { clearPopoverState, updatePopoverState } from './utils';

const initialState: Popover = popover_default;

export const popoversSlice = createSlice({
  name: SLICE.POPOVERS,
  initialState,
  reducers: {
    updatePopover: {
      reducer: (state: Popover, action: PayloadAction<PopoverUpdate>) => {
        return updatePopoverState(state, action.payload.key, action.payload.data);
      },
      prepare: <K extends keyof Popover>(payload: PopoverUpdate<K>) => ({ payload }),
    },
    clearPopover: {
      reducer: (state: Popover, action: PayloadAction<PopoverClear>) => {
        return clearPopoverState(state, action.payload);
      },
      prepare: (payload: PopoverClear) => ({ payload }),
    },
    clearPopovers: () => {
      return initialState;
    },
  },
});

export const { updatePopover, clearPopover, clearPopovers } = popoversSlice.actions;

export default popoversSlice.reducer;
